import { render, staticRenderFns } from "./ShowTransportEstimationResult.vue?vue&type=template&id=12f8c0b2&"
import script from "./ShowTransportEstimationResult.vue?vue&type=script&lang=js&"
export * from "./ShowTransportEstimationResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports